import {useGetAutoDeliveryDetailsDcx} from '@/api/consumerApi';
import {AUTO_DELIVERY_INFO_BOX_SOURCES} from '@/types/content';
import AutoDeliveryDcxOnHoldInfoBox from '@/views/AutoDeliveryDcx/AutoDeliveryDcxOnHold/AutoDeliveryDcxOnHoldInfoBox';
import AutoDeliveryDcxStatusBadge from '@/views/AutoDeliveryDcx/AutoDeliveryDcxStatusBadge';

import AutoDeliveryDcxOrderFrequency from './components/AutoDeliveryDcxOrderFrequency';
import AutoDeliveryDcxWidgetContainer from './components/AutoDeliveryDcxWidgetContainer';
import AutoDeliveryDcxWidgetHeader from './components/AutoDeliveryDcxWidgetHeader';

type AutoDeliveryDcxStatusOnHoldWidgetProps = {
    className?: string;
};

const AutoDeliveryDcxStatusOnHold = ({className}: AutoDeliveryDcxStatusOnHoldWidgetProps) => {
    const {
        data: {autoDelivery, order},
    } = useGetAutoDeliveryDetailsDcx();
    const {minDeliveryDaysCount, maxDeliveryDaysCount, frequency, statusUpdateReason} = autoDelivery || {};
    const {orderId} = order || {};

    return (
        <AutoDeliveryDcxWidgetContainer className={className}>
            <AutoDeliveryDcxWidgetHeader orderId={orderId} />
            <AutoDeliveryDcxWidgetContainer.ContentContainer className='md:p-0'>
                <div className='flex flex-col gap-4 rounded-xl bg-primary-dark-5 p-4 md:bg-romance md:px-6 md:py-8'>
                    <AutoDeliveryDcxStatusBadge status='onHold' />
                    <AutoDeliveryDcxOrderFrequency
                        frequency={frequency}
                        minDeliveryDaysCount={minDeliveryDaysCount}
                        maxDeliveryDaysCount={maxDeliveryDaysCount}
                    />
                    <AutoDeliveryDcxOnHoldInfoBox
                        statusUpdateReason={statusUpdateReason}
                        source={AUTO_DELIVERY_INFO_BOX_SOURCES.DASHBOARD}
                        className='border-t border-solid border-mischka p-0 pt-4 md:border-none md:p-4'
                    />
                </div>
            </AutoDeliveryDcxWidgetContainer.ContentContainer>
        </AutoDeliveryDcxWidgetContainer>
    );
};

export default AutoDeliveryDcxStatusOnHold;
